
import { Component, Mixins } from "vue-property-decorator";
import { default as TextPresentableObjectDrawerBase } from "./TextPresentableObjectDrawerBase.vue";
import { CategoryNamePropertyEditableMixin, CheckBehaviorPropertyEditableMixin } from "../../../mixins/properties";

@Component
export default class CheckableObjectDrawerBase extends Mixins(TextPresentableObjectDrawerBase, CategoryNamePropertyEditableMixin, CheckBehaviorPropertyEditableMixin) {}
